import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Box, Button, } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"
import { useNavigate, useLocation } from 'react-router-dom';
import BucketBox from '../../components/BucketBox';
import BigBucketBox from '../../components/BigBucketBox';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import EditIcon from '@mui/icons-material/Edit';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import CurrencyFormat from 'react-currency-format';
import { Link as ReactLink } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from "../../hooks/handleError";



const Buckets = () => {

    useEffect(() => {
        document.title = 'Buckets | Fretless Finance';
    }, []);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    var [buckets, setBuckets] = useState([]);
    const effectRan = useRef(false);
    // var isMounted = useRef(false);
    const controller = new AbortController();
    var isMounted = false;





    useEffect(() => {
        if (effectRan.current === false) {

            let isMounted = true;
            const controller = new AbortController();

            const getBuckets = async () => {
                try {
                    var BucketsResponse = await axiosPrivate.get('/buckets', {
                        signal: controller.signal
                    });
                    // isMounted && setBuckets(BucketsResponse.data);
                    console.log(BucketsResponse)
                    isMounted && setBuckets(BucketsResponse.data)

                } catch (err) {
                    if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    }
                    else {
                        handleError(err);
                    }
                }
            }

            getBuckets();
            effectRan.current = true;
        }
        return () => {
            isMounted = false;
            controller.abort();

        }


    }, [])

    const updateBuckets = async () => {
        try {
            var BucketsResponse = await axiosPrivate.post('/buckets/refresh', {
                signal: controller.signal
            });


        } catch (err) {
            if ((err.response?.status === 401) || (err.response?.status === 403)) {
                navigate('/sign-in', { state: { from: location }, replace: true });
            }
            else {
                handleError(err);
            }
        }
    }

    const getBuckets = async () => {
        try {
            var BucketsResponse = await axiosPrivate.get('/buckets', {
                signal: controller.signal
            });
            // isMounted && setBuckets(BucketsResponse.data);
            console.log(BucketsResponse)
            isMounted && setBuckets(BucketsResponse.data)

        } catch (err) {
            if ((err.response?.status === 401) || (err.response?.status === 403)) {
                navigate('/sign-in', { state: { from: location }, replace: true });
            }
            else {
                handleError(err);
            }
        }
    }

    const handleUpdateBucketsClick = event => {
        updateBuckets();
        getBuckets();
    }




    return (
        <Box m="20px">
            <Header
                title="BUCKETS"
                titleSize="h2"
                subtitle="Imaginary buckets ya keep ya money in"
                subtitleSize="h5"
            />
            < ToastContainer />
            <Box
                display="grid"
                gridTemplateColumns="repeat(2, 1fr)"
                justifyContent="center"
            >
                <Button component={ReactLink} to="/buckets/edit" variant="contained"
                    sx={{
                        width: "175px",
                        mb: "20px",
                        backgroundColor: colors.blueAccent[400],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.blueAccent[100],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                    }}
                >
                    <EditIcon sx={{ mr: "10px" }} />
                    Edit Buckets
                </Button>
                <Button
                    onClick={() => { handleUpdateBucketsClick() }}
                    sx={{
                        height: "50px",
                        width: "175px",
                        marginRight: "0%",
                        backgroundColor: colors.blueAccent[400],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.blueAccent[100],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        gridColumn: "12",
                        justifySelf: "end",
                    }}
                >
                    <SyncAltIcon sx={{ mr: "10px" }} />
                    Update Buckets
                </Button>
            </Box>


            <Box
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gridAutoRows="140px"
                gap="20px"
                justifyContent="center"
            >
                {buckets.filter((bucket) => (bucket.bucket_type === "primary")).map((parent_bucket) => (
                    < Box
                        gridColumn="span 12"
                        gridRow="span 4"
                        backgroundColor={colors.primary[400]}
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        gridAutoRows="70px"
                        gap="70px"
                        justifyContent="center"
                    >
                        < Box marginTop="90px" gridColumn="span 4" >
                            <BigBucketBox
                                amount={<CurrencyFormat
                                    thousandSeparator=","
                                    prefix="$"
                                    decimalScale={2}
                                    value={parent_bucket.amount / 100000000}
                                    displayType="text"
                                    style={{ color: parent_bucket.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                />
                                }
                                cap={<CurrencyFormat
                                    thousandSeparator=","
                                    prefix="$"
                                    decimalScale={2}
                                    value={parent_bucket.cap / 100000000}
                                    displayType="text"
                                    style={{ color: colors.blueAccent[700] }}
                                />
                                }
                                title={parent_bucket.name}
                                progress={parent_bucket.amount / parent_bucket.cap}
                                increase="+14%"
                                icon={
                                    <SavingsOutlinedIcon
                                        sx={{ color: colors.blueAccent[300], fontSize: "150px" }}
                                    />
                                }
                            />
                        </Box>
                        < Box
                            gridColumn="span 8"
                            gridRow="span 2"
                            backgroundColor={colors.primary[400]}
                            display="grid"
                            gridTemplateColumns="repeat(7, 1fr)"
                            gridAutoRows="120px"
                            gap="70px"
                            justifyContent="center"
                        >
                            {buckets.filter((bucket) => (bucket.parent_bucket === parent_bucket.name)).map((bucket) => (
                                < Box marginTop="40px" mr="25%" gridColumn="span 2" >
                                    <BucketBox

                                        amount={<CurrencyFormat
                                            thousandSeparator=","
                                            prefix="$"
                                            decimalScale={2}
                                            value={bucket.amount / 100000000}
                                            displayType="text"
                                            style={{ color: bucket.amount > 0 ? colors.greenAccent[400] : colors.redAccent[400] }}
                                        />
                                        }
                                        cap={<CurrencyFormat
                                            thousandSeparator=","
                                            prefix="$"
                                            decimalScale={2}
                                            value={bucket.cap / 100000000}
                                            displayType="text"
                                            style={{ color: colors.blueAccent[700] }}
                                        />
                                        }
                                        title={bucket.name}
                                        progress={bucket.amount / (bucket.cap + 1)}
                                        icon={
                                            <SavingsOutlinedIcon
                                                sx={{ color: colors.blueAccent[300], fontSize: "26px" }}
                                            />
                                        }
                                    />
                                </Box>
                            ))}
                        </Box>

                    </Box>
                ))}
            </Box>

        </Box >
    );
};

export default Buckets;